document.addEventListener("DOMContentLoaded", function() {

	var $ = jQuery.noConflict();

    // Variations as Radio Buttons on radio button change(click)
	$( document ).on('change','.tfa-variation-radios input', function() {
		// for each checked radio button we reflect the same changes to select dropdowns
		$('.tfa-variation-radios input:checked').each( function( index, element ) {
			const radio = $(element)
			const radioName = radio.attr( 'name' )
			const radioValue  = radio.attr( 'value' )
			$( 'select[name="' + radioName + '"]' ).val( radioValue ).trigger( 'change' );
		})
	});

	$('.woocommerce.wc-block-catalog-sorting select.orderby option:last-child').remove();

    // Filter by Cat UI close btn
	$('.wpc-filter-content.wpc-filter-product_cat').trigger('click');
	
	$(document).on('click','.wpc-filter-content.wpc-filter-product_cat', function() {
		$('.wpc-filter-product_cat button').trigger('click');
	});

	//Cover & Cover finder page reload after filter for Fancybox popup path reload
	$(document).on('click','body.woocommerce-shop .wpc-filters-ul-list li, body.cover-finder .wpc-filter-layout-submit-button, .wpc-chip-reset-all', function() {
		setTimeout(function () {
			$('.fancybox-inline').fancybox();
		}, 1200);
	});

	// First child variations always checked (radio btn)
	$('table.variations .tfa-variation-radios').each(function() {
		$(this).find('label:first').trigger('click');
	});

	// Hide variations if only area and one price
	$('#attribute_pa_area-europe,  #attribute_pa_area-uk').trigger('click');	
	$('.section__updates .wp-block-query ul.wp-block-post-template').append('<li class="wp-block-post--ask-box"><a href="#q">Frequently Asked <br>Questions</a></li>');
	$('#attribute_pa_quantity-4').next('label').append('<a href="../../product-tag/4th-free/" rel="tag" class="nth-car free">4th free</a>');

	// Single Product Price variables
	var n_price = $('body.single-product .col-lg-5 .wc-block-grid__product-price').children('span.woocommerce-Price-amount.amount').length;
	$('#attribute_pa_pay-monthly-or-yearly').parent().addClass('attribute_pa_pay-monthly-or-yearly');

	setTimeout(function() {
		$('body.single-product .attribute_pa_pay-monthly-or-yearly, body.single-product #attribute_pa_area, body.single-product #attribute_pa_assistance-at-home-address').parent().addClass('hidden');
	}, 500);

	$('#attribute_pa_pay-monthly-or-yearly-monthly').trigger('click');

	if ( $('body.single-product .attribute_pa_pay-monthly-or-yearly').length == 0 ) {
		$('.product-price-switch .form-check-input, .product-price-switch .monthly, .product-price-switch .form-check-label.info').hide();
	}

	$('.form-switch').on('click', function() {

		if ($('input#flexSwitchCheckChecked').is(':checked')) {
			$('#attribute_pa_pay-monthly-or-yearly-monthly').click();
		} else {
			$('#attribute_pa_pay-monthly-or-yearly-yearly').click();
		}
	});

	$('body').on('click change','form.variations_form.cart', function() {

		if ( $('.single_variation_wrap .single_variation div').length ) {
			$('.single-product .wp-block-tfa-column.col-lg-5').addClass('active');
		}

		if ( n_price <= '1' ) {
			$('.single-product .wp-block-tfa-column.col-lg-5').removeClass('active');
		}
	});

	$('.reset_variations').on('click', function() {
		$('.single-product .wp-block-tfa-column.col-lg-5').removeClass('active');
	});

	function Tags() {

		$('.taxonomy-product_tag a').each(function() {
			var class_name = $(this).text().toLowerCase().replace(/\d+/g,'n').replace(' ','-');		
			$(this).addClass(class_name);
		});
	}
	Tags();

	$('body').on('click change','.wp-block-query', function() {		
		Tags();
	});
});